import { TFunction } from "i18next";

import { Filter } from "@/components/molecules";
import { InvoiceCategory } from "@/shared/domain/invoices";

export const getAvailableFilters = (
    invoicesPaidTotal: number,
    invoicesUnpaidTotal: number,
    invoicesOthersTotal: number,
    t: TFunction,
): Filter[] => {
    const availableFilters: Filter[] = [];

    const numberOfNotEmptyCategories = [!!invoicesPaidTotal, !!invoicesUnpaidTotal, !!invoicesOthersTotal].filter(
        Boolean,
    ).length;
    if (numberOfNotEmptyCategories === 1) return availableFilters;

    availableFilters.push({
        id: InvoiceCategory.ALL,
        label: t("Invoices.All"),
        quantity: invoicesPaidTotal + invoicesUnpaidTotal + invoicesOthersTotal,
    });

    availableFilters.pushIf(invoicesUnpaidTotal, {
        id: InvoiceCategory.NOT_PAID,
        label: t("Invoices.ToPay"),
        quantity: invoicesUnpaidTotal,
    });

    availableFilters.pushIf(invoicesPaidTotal, {
        id: InvoiceCategory.PAID,
        label: t("Invoices.Paid"),
        quantity: invoicesPaidTotal,
    });

    availableFilters.pushIf(invoicesOthersTotal, {
        id: InvoiceCategory.OTHERS,
        label: t("Invoices.Others"),
        quantity: invoicesOthersTotal,
    });
    return availableFilters;
};
